<template>
  <div :class="certification ? 'login_wrap clear_mtop' : 'login_wrap'">
    <div class="login_box">
      <div>
        <div class="tit_box">
          <h1 :class="{ 'login-title': certification }">
            {{ certification ? '登录' : '登录企业' }}
          </h1>
          <!-- <div v-if="!certification" style="height: 40px; line-height: 40px">
            <span>企业未注册？</span>
            <a @click="handleRegister">注册企业</a>
          </div> -->
        </div>
        <div class="mt28 login_register_form">
          <signin />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Signin from './components/Signin';

export default {
  name: 'Login',
  components: {
    Signin
  },
  data() {
    return {
      certification: window.location.href.indexOf('certification') > -1
    };
  },
  created() {},
  methods: {
    getRedirect() {
      let redirect = this.$route.fullPath;
      if (this.$route.query.redirect) {
        redirect = this.$route.query.redirect;
      }
      // 判断redirect的页面是不是/manage/login，是则返回信息‘manage’，不是就直接返回redirect中的信息
      if (redirect == '/enterprise/login') {
        return '/manage/overview/';
      }
      return redirect;
    },
    // 跳转注册页面，并把重定向的参数带上。
    handleRegister() {
      const certification = window.location.href.indexOf('certification') > -1;
      this.$router.push({
        name: certification ? 'certificationRegister' : 'register',
        query: { redirect: this.getRedirect() }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.login_wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  .boeLogo {
    width: 611px;
  }
  .login_box {
    width: 480px;
    border-radius: 20px;
    border: 1px solid #ccc;
    background: #ffffff;
    min-height: 400px;
    box-sizing: border-box;
    padding: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    & > div {
      width: 100%;
    }
    .tit_box {
      display: flex;
      justify-content: space-between;
      h1 {
        font-size: 16px;
      }
      span {
        opacity: 0.8;
      }
    }
  }
}
.clear_mtop {
  margin: 0 !important;
}
.login-title {
  font-size: 24px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue